import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form'
import { FormInstance } from 'antd'

export async function legacyValidateFields(form: WrappedFormUtils<any>, excludeFields: string[] = []): Promise<any> {
    const fieldNames = Object.keys(form.getFieldsValue()).filter((f) => excludeFields.indexOf(f) === -1)

    return new Promise((resolve, reject) => {
        form.validateFields(fieldNames, { force: true }, (errors: any, values: any) => {
            if (errors) {
                reject(errors)
            } else {
                resolve(values)
            }
        })
    })
}

export async function validateFields(form: FormInstance<any>, excludeFields: string[] = []): Promise<any> {
    const fieldNames = Object.keys(form.getFieldsValue()).filter((f) => excludeFields.indexOf(f) === -1)
    return form.validateFields(fieldNames)
}
